import {Injectable} from "@angular/core";
import {PrefabCacheService} from "@wms/services";
import {runtimeEventManager} from "@wm/core";
import {IPageMinJSON} from "@wms/app/design-container";

@Injectable({
  providedIn: 'root'
})
export class AppPrefabResourceManagerService {
  constructor(private prefabCacheService: PrefabCacheService) {
    runtimeEventManager.setService('AppPrefabResourceManagerService', this);
  }

  getPageDataForPrefab(prefabName: string, pageNameInPrefab: string = 'Main'): Promise<IPageMinJSON> {
    return this.prefabCacheService.getPrefabDataByType({
      type: 'pages',
      prefabName: prefabName,
      pageNameInPrefab: pageNameInPrefab
    });
  }

}
